import { render, staticRenderFns } from "./NavbarAluno.vue?vue&type=template&id=74caf5e4&scoped=true"
import script from "./NavbarAluno.vue?vue&type=script&lang=js"
export * from "./NavbarAluno.vue?vue&type=script&lang=js"
import style0 from "./NavbarAluno.vue?vue&type=style&index=0&id=74caf5e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74caf5e4",
  null
  
)

export default component.exports